import type { TableCommandFactory } from 'components/Table/model/TableModel';
import { saveTableSettings } from 'components/Table/model/commands/saveTableSettings';

interface SetAutoSizedColumnsCommand {
  value: boolean;
}

export const setAutoSizedColumns: TableCommandFactory<
  SetAutoSizedColumnsCommand
> = (cmdContext, dispatch) => async (command) => {
  cmdContext.updateState((draft) => {
    draft.settings.autoSizedColumns = command.value;
    draft.requestedAutoSize = true;
  });
  await dispatch(saveTableSettings);
};
